import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import type { Carrier } from './carrierDaily'

/** The chart's legend: one chip per carrier that hides or shows its line. */
export function CarrierToggles({
  carriers,
  hidden,
  onToggle,
}: {
  carriers: Carrier[]
  hidden: ReadonlySet<string>
  onToggle: (vendor: string) => void
}) {
  return (
    <div className="flex flex-wrap gap-2" role="group" aria-label="Carriers">
      {carriers.map((carrier) => {
        const shown = !hidden.has(carrier.vendor)
        return (
          <Button
            key={carrier.vendor}
            variant="outlineThin"
            size="xs"
            aria-pressed={shown}
            onClick={() => onToggle(carrier.vendor)}
            className={cn(!shown && 'text-ink-400 line-through')}
          >
            <span
              aria-hidden
              className="h-0.5 w-3 rounded-full"
              style={{ backgroundColor: shown ? carrier.color : 'currentColor' }}
            />
            {carrier.name}
          </Button>
        )
      })}
    </div>
  )
}
